import { ApiType } from "@gymflow/common";
import { useMutation } from "@tanstack/react-query";

export function useMutationSendEmailToMembers({ api }: { api: ApiType }) {
  return useMutation({
    mutationFn: async (
      payload: Parameters<ApiType["emailApi"]["sendEmailToMembers"]>[0],
    ) => {
      return (await api.emailApi.sendEmailToMembers(payload)).data;
    },
  });
}
